import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'
import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js'

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    editor: RichTextEditor
  },

  props: {
    activeTab: {
      type: String
    },
    helpHtmlData: {
      type: Object
    }
  },

  data() {
    return {
      helpHtml: this.helpHtmlData.help_html || '',
      paths: this.helpHtmlData.paths,
      saving: false
    }
  },

  template: `
    <settings-container :activeTab="activeTab">
      <template slot="content">
        <div class="help-html-settings">
          <div class="panel-card">
            <div class="panel-card-head">
              <span class="panel-card-title">联系管理员</span>
            </div>
            <div class="panel-card-body">
              <div class="help-html-editor-field">
                <editor :value="helpHtml"
                        placeholder="请输入 ..."
                        scrollingContainer="main>.main-content"
                        @valueChanged="onHelpHtmlChange" />
              </div>
            </div>
          </div>
        </div>
        <div class="content-footer">
          <button class="content-footer-btn"
                  :disabled="saving"
                  @click="updateSettings">
            {{ saving ? '更新中...' : '更新' }}
          </button>
        </div>
      </template>
    </settings-container>
  `,

  methods: {
    onHelpHtmlChange(value) {
      this.helpHtml = value
    },

    updateSettings() {
      this.saving = true
      Skylark.Libs.Ajax.patch(this.paths.update, {
        data: {
          namespace: {
            help_html: this.helpHtml
          }
        },
        responseType: 'json',
        success: (data) => {
          this.helpHtml = data.help_html
          Skylark.Bridge.newAlertify('联系管理员文案更新成功', { type: 'success' })
        },
        error: () => {
          Skylark.Bridge.newAlertify('联系管理员文案更新失败', { type: 'danger' })
        },
        complete: () => {
          this.saving = false
        }
      })
    }
  }
})
